import { render } from "./BasketTimesChart.vue?vue&type=template&id=a6c18f46&scoped=true"
import script from "./BasketTimesChart.vue?vue&type=script&lang=js"
export * from "./BasketTimesChart.vue?vue&type=script&lang=js"

import "./BasketTimesChart.vue?vue&type=style&index=0&id=a6c18f46&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/BEELIA/mi-stock-beelia-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c18f46"]])

export default __exports__